import PropTypes from "prop-types";
import searchIcon from "./search.svg";
import styles from "./SearchInput.module.scss";

const SearchInput = ({
  searchInputValue,
  handleOnSearch,
  handleSearchClick,
  placeholder = "Search",
  searchIconSrc = searchIcon,
}) => {
  const handleKeyDown = (event) => {
    if (event.key === "Enter" && searchInputValue.length > 1) {
      handleSearchClick(searchInputValue);
    }
  };

  return (
    <div className={styles.searchInputContainer}>
      <input
        id="searchInput"
        type="text"
        className={`form-control ${styles.searchInput} rounded-start`}
        placeholder={placeholder}
        value={searchInputValue}
        onChange={handleOnSearch}
        onKeyDown={handleKeyDown}
        style={{border: 'none'}}
      />
      <button
        className={`btn ${styles.searchBtn}`}
        onClick={() => {
          if (searchInputValue.length > 1) {
            handleSearchClick(searchInputValue);
          }
        }}
      >
        <img src={searchIconSrc} alt="Search" className={styles.searchIcon} />
      </button>
    </div>
  );
};

SearchInput.propTypes = {
  searchInputValue: PropTypes.string.isRequired,
  handleOnSearch: PropTypes.func.isRequired,
  handleSearchClick: PropTypes.func.isRequired,
  handleKeyDown: PropTypes.func,
  placeholder: PropTypes.string,
  searchIconSrc: PropTypes.string,
};

export default SearchInput;



